<template>
  <div class="gdpr">
    <ValidationProvider
      v-slot="{ errors }"
      :rules="{ required: { allowFalse: false } }"
      name="consent to the processing of personal data"
    >
      <span class="checkbox">
        <input
          :id="`agreement-${identifier}`"
          v-model="agreement"
          class="check_boxes optional"
          type="checkbox"
          :name="`agreement-${identifier}`"
        />
        <label class="collection_check_boxes" :for="`agreement-${identifier}`">
          I agree
          <a href="#" @click.prevent="showModal">to the processing of personal data</a>
        </label>
      </span>
      <span v-if="errors[0]" class="invalid-feedback d-block">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import GdprModal from "./GdprModal.vue";

export default {
  name: "Gdpr",
  props: ["identifier"],
  data() {
    return {
      agreement: ""
    };
  },
  methods: {
    showModal() {
      this.$modal.show(
        GdprModal,
        {},
        {
          adaptive: true,
          width: "100%",
          height: "auto",
          maxWidth: 1200,
          scrollable: true
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.invalid-feedback {
  margin-bottom:10px;
}
</style>
